import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAppStore = create(
  persist(
    (set, get) => ({
      // Search state
      searchQuery: '',
      searchCategory: 'symptoms',
      searchResults: [],
      isSearching: false,
      
      // User state
      user: null,
      isAuthenticated: false,
      
      // Appointment state
      selectedDoctor: null,
      selectedTimeSlot: null,
      appointmentDetails: null,
      
      // UI state
      mobileMenuOpen: false,
      selectedSymptom: null,
      searchSuggestions: [],
      
      // Actions
      setSearchQuery: (query) => set({ searchQuery: query }),
      setSearchCategory: (category) => set({ searchCategory: category }),
      setSearchResults: (results) => set({ searchResults: results }),
      setIsSearching: (isSearching) => set({ isSearching }),
      
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      logout: () => set({ user: null, isAuthenticated: false }),
      
      setSelectedDoctor: (doctor) => set({ selectedDoctor: doctor }),
      setSelectedTimeSlot: (timeSlot) => set({ selectedTimeSlot: timeSlot }),
      setAppointmentDetails: (details) => set({ appointmentDetails: details }),
      
      setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),
      setSelectedSymptom: (symptom) => set({ selectedSymptom: symptom }),
      setSearchSuggestions: (suggestions) => set({ searchSuggestions: suggestions }),
      
      // Reset functions
      resetSearch: () => set({ 
        searchQuery: '', 
        searchResults: [], 
        isSearching: false,
        selectedSymptom: null 
      }),
      
      resetAppointment: () => set({
        selectedDoctor: null,
        selectedTimeSlot: null,
        appointmentDetails: null
      }),
    }),
    {
      name: 'healthcare-app-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAppStore;
